module.exports = __webpack_public_path__ + "img/svg/background-home.58b650a3f271217241e665e3fab981b7.svg";